import React from "react";
import "../Bouquets/BannerBouque";

const BannerBalloon = () => {
  return (
    <div className="banner-bouque-container">
      <h2 className="banner-bouque-title">HAND CRAFTED BALLOONS</h2>
      <p className="banner-bouque-description">
        Whatever the occasion, we use only the highest quality balloons,
        ensuring they look stunning and last beautifully. Whether it's a
        birthday, anniversary, or just because, our hand-crafted balloons are
        sure to delight your loved ones
      </p>
    </div>
  );
};

export default BannerBalloon;
